import { API_URL } from "../constants";
import { apiRequest } from "./apiRequest";

export const getUrl = () => `${API_URL}/api/v1/admin/report/per-rep-metrics`;

const getRepMetrics = async () => await apiRequest(getUrl(), "get");

export default getRepMetrics;

